// Copyright (c) 2020 WiseTime. All rights reserved.

import enGB from "date-fns/locale/en-GB"
import fr from "date-fns/locale/fr"
import de from "date-fns/locale/de"
import { i18n } from "@lingui/core"
import { en, fr as frPlural, de as dePlural } from "make-plural"
import catalogEn from "./i18n/en/messages"
import catalogFr from "./i18n/fr/messages"
import catalogDe from "./i18n/de/messages"

const languagesList = ["en", "fr", "de"]

export const getDefaultLanguage = (): string => {
  const navigatorLanguage = ((navigator.languages && navigator.languages[0]) ?? navigator.language).slice(0, 2)
  if (languagesList.find(l => l === navigatorLanguage)) {
    const bodyClassName = `lang-${navigatorLanguage}`
    if (document.body && !document.body.classList.contains(bodyClassName)) {
      /*
       * for fixing UI issues which are related to specific language,
       * too wide text string, alignment etc.
       */
      document.body.classList.add(bodyClassName)
    }
    return navigatorLanguage
  }
  return "en"
}

export const datepickerLocales: Record<string, Locale> = {
  en: enGB,
  fr,
  de,
}

export const getDatepickerLocale = (): Locale => (datepickerLocales[getDefaultLanguage()] ?? datepickerLocales.en as Locale)

/**
 * If lingui macros are used in non-React files, we need to
 * call this method at the beginning. Otherwise, translations cannot be
 * loaded successfully.
 */
export const activateI18n = () => {
  i18n.loadLocaleData("en", { plurals: en })
  i18n.loadLocaleData("fr", { plurals: frPlural })
  i18n.loadLocaleData("de", { plurals: dePlural })
  i18n.load("en", catalogEn.messages)
  i18n.load("fr", catalogFr.messages)
  i18n.load("de", catalogDe.messages)
  i18n.activate(getDefaultLanguage())
}
